import React from "react";

class Icon extends React.Component {
	convert(text) {
		return text
			.split(/(?=[A-Z])/)
			.join("-")
			.toLowerCase();
	}
	render() {
		return (
			<i
				className={`fa${this.props.fas ? "s" : ""}${
					this.props.fab ? "b" : ""
				} ${this.convert(this.props.icon)}${this.props.spin ? " fa-spin" : ""}${
					this.props.size ? " " + "fa-" + this.props.size.toLowerCase() : ""
				}${this.props.className ? " " + this.props.className : ""}`}
			/>
		);
	}
}
export default Icon;
